import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

class BillingInformation extends Component {
  render() {
    const { address, unit, city, province } = this.props;

    return (
      <Fragment>
        <li>{address}</li>
        {unit && <li>{unit}</li>}
        <li>{city}, {province}</li>
      </Fragment>
    );
  }

}

BillingInformation.defaultProps = {
  address: "",
  unit: null,
  city: "",
  province: "",
}

BillingInformation.propTypes = {
  address: PropTypes.string.isRequired,
  unit: PropTypes.string,
  city: PropTypes.string.isRequired,
  province: PropTypes.string.isRequired,
};

export default BillingInformation;
